import { darken } from 'polished'

export const colors = {
  primary: '#0045D3',
  warning: '#f44f56',
  darkerPrimary: darken(0.2, '#0045D3'),
  white: '#fff',
}
